import { BaseService } from '@services/BaseService';
import { AccountViewModel } from '@models/Account';
import { SimpleAccountViewModel } from '../_models/SimpleAccountViewModel';

class AccountService extends BaseService {
  constructor() {
    super('accounts');
  }

  getAccount(id: number): Promise<AccountViewModel> {
    return this.fetch<AccountViewModel>(`${id}`, {
      method: 'GET'
    });
  }

  saveCardFromTransactionToAccount(transactionId: number, account: SimpleAccountViewModel) {
    return this.fetch<void>(`${account.id}/cards?fromTransaction=${transactionId}`, {
      method: 'PUT',
      body: JSON.stringify(account)
    });
  }

  deleteAccount(id: number) {
    return this.fetch<AccountViewModel>(`${id}`, {
      method: 'DELETE'
    });
  }
}

export const accountService = new AccountService();



// WEBPACK FOOTER //
// ./src/_services/AccountService.ts